import { render } from "./QwTag.vue?vue&type=template&id=310575ee"
import script from "./QwTag.vue?vue&type=script&lang=js"
export * from "./QwTag.vue?vue&type=script&lang=js"

import "./QwTag.vue?vue&type=style&index=0&id=310575ee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__